import { all } from "redux-saga/effects";
import stepShippingSagas from "./StepShipping/StepShipping/sagas.js";
function* sagas() {
  yield all(stepShippingSagas);
}
export {
  sagas as default
};
//# sourceMappingURL=sagas-registry.js.map
